import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { PickRead } from '../../entities/pick.dto';

@Injectable()
export class PickStore extends AbstractEntityStore<PickRead> {
    constructor() {
        super(PFWmsEntities.Pick);
    }
}
